import React from 'react';
import classnames from 'classnames';

import { importStatic } from 'utils';

import { SORT_DIRECTIONS } from '../common';

import classes from '../table.module.css';

const Asc = ({ isSelected }) => (
  <img
    src={importStatic('/ui-router/images/top_sort_unselected.png')}
    className={classnames('position-relative z-m-1', {
      selected: isSelected,
    })}
    alt={SORT_DIRECTIONS.ASC}
    width="8"
    height="5"
  />
);

const Desc = ({ isSelected }) => (
  <img
    src={importStatic('/ui-router/images/bottom_sort_unselected.png')}
    className={classnames('position-relative z-m-1', {
      selected: isSelected,
    })}
    alt={SORT_DIRECTIONS.DESC}
    width="8"
    height="5"
  />
);

export default function HeadCol({ text, isHiddenMobile, showCaret, sortValue, onClick }) {
  return (
    <th
      className={classnames(
        classes.head,
        'z-pr-0 z-pr-md-4 z-pl-20 z-pb-17 position-relative custom-table-head semi-bold-font',
        {
          [classes.selected]: sortValue,
          'd-none d-md-table-cell': isHiddenMobile,
        }
      )}
      onClick={onClick}
    >
      <span className={classes.text}>{text}</span>
      {<>&nbsp;&nbsp;</>}
      {showCaret && (
        <a className={classnames(classes.sort, 'd-inline-block text-center z-ml-4 sortyby')}>
          {sortValue === 'asc' && <Asc isSelected />}
          {sortValue === 'desc' && <Desc isSelected />}
          {!sortValue && (
            <>
              <Asc />
              <Desc />
            </>
          )}
        </a>
      )}
    </th>
  );
}
